// extracted by mini-css-extract-plugin
module.exports = {"contents":"Ol","sectionHeading":"Pl"};